import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PostCard from "../components/postCard"
import Signup from "../components/signup"

import "../utils/styles.css"
import "../utils/normalize.css"
import "../utils/css/screen.css"

const BlogIndex = ({ data, location }) => {
  // console.error("Missing data:", data)
  
  // if (!data || !data.site) {
  //   console.error("Missing data:", data)
  //   return null // or fallback UI
  // }
  
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges
  let postCounter = 0


  return (
    <Layout title={siteTitle}>
      <SEO
        title="Organic Precision"
        keywords={[
          `Parametric`,
          `Wall Sculpture`,
          `Contemporary Art`,
          `Dimensional Wall Art`,
          `3D Wall Art `,
          `Modern Art`,
          `Flower Art`,
          `Mosaic Art`,
          `Wood Wall Art`,
          `Sacred Geometry`,
          `Abstract Art`,
          `Wall Object`,
          `3D Printing`,
          `Mandala Art`,
          `Geometric Art`,
          `Trippy Art`,
        ]}
      />
 
      <header className="page-head" style={{padding: "5vh 0 5vh 0", maxWidth: "800px"}}>
          <h2 style={{fontSize: "3.5rem"}}>
          Sculptures Forged in Organic Precision
          </h2>
       

        <div style={{marginTop: "2em", marginBottom: "0em"}}><Signup/></div>
        </header>
      {/* <div style={{ display: "flex", justifyContent: "center", marginBottom: "50px"}}><Signup/></div> */}

      <div className="post-feed">
        {posts.map(({ node }) => {
          postCounter++
          return (
            <PostCard
              key={node.fields.slug}
              count={postCounter}
              node={node}
              postClass={`post`}
            />
          )
        })}
      </div>
    </Layout>
  )
}


export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }

    allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "/content/blog/"}}
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            thumbnail {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 640)
              }
            }
            available
          }
        }
      }
    }
  }
`

export default BlogIndex

